import axios from 'axios'
import router from '@/router'
import Vue from 'vue'
import BVToastPlugin from 'bootstrap-vue'
Vue.use(BVToastPlugin)

function handleMildAxiosError (exception) {
  const vm = new Vue()
  vm.$bvToast.toast('Es ist ein Fehler aufgetreten. ' + exception, {
    title: 'Fehler!',
    autoHideDelay: 5000,
    appendToast: true,
    variant: 'danger'
  })
}

export default {
  getArticles ({ commit }, page = 1) {
    axios.get(process.env.VUE_APP_API_URL + `/article?page=${page}`)
      .then(response => (commit('storeArticles', response.data)))
      .catch(e => {
        handleMildAxiosError(e)
      })
  },
  getArticleById ({ commit }, articleId) {
    axios.get(process.env.VUE_APP_API_URL + `/article/${articleId}`)
      .then(response => (commit('storeArticle', response.data)))
      .catch(e => {
        handleMildAxiosError(e)
      })
  },
  getWarnings ({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + '/warning')
      .then(response => (commit('storeWarnings', response.data.data)))
      .catch(e => {
        handleMildAxiosError(e)
      })
  },
  getLatestEvents ({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + '/event/next')
      .then(response => {
        commit('clearLatestEvents')
        for (const event of response.data.data) commit('storeLatestEvent', event)
      })
      .catch(e => {
        handleMildAxiosError(e)
      })
  },
  getQuickAccess ({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + '/quickaccess')
      .then(response => {
        commit('storeQuickAccess', response.data.data)
      })
      .catch(e => {
        handleMildAxiosError(e)
      })
  },
  async getDropdowns ({ commit }) {
    let page = 1
    let lastPage = false
    while (lastPage === false) {
      await axios.get(process.env.VUE_APP_API_URL + `/dropdown?page=${page}`)
        .then(response => {
          for (const dropdown of response.data.data) commit('storeDropdown', dropdown)
          if (response.data.last_page === page) lastPage = true
          page++
        })
        .catch(e => {
          lastPage = true
          handleMildAxiosError(e)
        })
    }
  },
  async getNavigation ({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + '/navigation')
      .then(response => {
        commit('storeNav', response.data.data)
        for (const entry of response.data.data) {
          if (entry.type === 'dropdown') {
            for (const site of entry.sites) commit('storeSite', site)
          }
        }
      })
      .catch(e => {
        handleMildAxiosError(e)
      })
  },
  async getSitesForDropdown ({ commit }, dropdownId) {
    let page = 1
    let lastPage = false
    while (lastPage === false) {
      await axios.get(process.env.VUE_APP_API_URL + `/site?page=${page}&dropdown_id=${dropdownId}`)
        .then(response => {
          for (const site of response.data.data) commit('storeSite', site)
          if (response.data.last_page === page) lastPage = true
          page++
        })
        .catch(e => {
          lastPage = true
          handleMildAxiosError(e)
        })
    }
  },
  async getSectionsForSite ({ commit, getters }, siteId) {
    const key = getters.getKey
    let page = 1
    let lastPage = false
    while (lastPage === false) {
      await axios.get(process.env.VUE_APP_API_URL + `/site/${siteId}/section?page=${page}&key=${key}`)
        .then(response => {
          for (const section of response.data.data) commit('storeSection', section)
          if (response.data.last_page === page) lastPage = true
          page++
          commit('siteUnlocked', parseInt(siteId))
        })
        .catch(error => {
          lastPage = true
          if (error.response && error.response.data && error.response.data.message === 'This site is Private.') {
            console.log(error.response.data.message)
          } else if (error.response && error.response.data && error.response.data.message === 'The key is invalid.') {
            const vm = new Vue()
            const h = vm.$createElement
            const vNodesTitle = h(
              'div',
              [
                h('b-icon-exclamation-triangle', { props: { variant: 'warning' } }),
                h('strong', { class: 'ml-2' }, 'Fehler.')
              ]
            )
            vm.$bvToast.toast('Das Passwort ist falsch!', {
              title: [vNodesTitle],
              autoHideDelay: 5000
            })
          } else {
            handleMildAxiosError(error)
          }
        })
    }
  },
  getSite ({ commit }, siteId) {
    axios.get(process.env.VUE_APP_API_URL + `/site/${siteId}`)
      .then(response => {
        commit('storeSite', response.data.data)
      })
      .catch((e) => {
        console.error(e)
        handleMildAxiosError(e)
      })
  },
  createExcuse ({ commit }, form) {
    axios.post(process.env.VUE_APP_API_URL + '/excuse', {
      description: form.text,
      parent_name: form.parentName,
      child_name: form.childName,
      start: form.start,
      end: form.end,
      email: form.email,
      grade: form.classOneToFour,
      grade_specification: form.classAbc
    })
      .then(() => {
        const vm = new Vue()
        vm.$bvToast.toast('Die Entschuldigung wurde gespeichert', {
          title: 'Erfolgreich!',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'success'
        })
        router.push('/')
      })
      .catch(exception => {
        console.error(exception)
      })
  }
}
